import DossierStore from '../stores/dossierStore'

const dossierStore = new DossierStore()

export default dossierStore
